import { Auth } from '~/amplify';

/**
 * Thrown when SMS MFA is requested but TOTP is not already enabled.
 * SMS is a backup method only after the authenticator app is on.
 */
export class TotpRequiredForSmsError extends Error {
  constructor() {
    super('TOTP must be enabled before enabling SMS MFA');
    this.name = 'TotpRequiredForSmsError';
  }
}

/**
 * Enables SMS MFA preference only when TOTP is already enabled.
 */
const enableSmsMfaPreference = async (): Promise<void> => {
  const preferences = await Auth.fetchMFAPreference();
  const totpEnabled = preferences.enabled?.includes('TOTP') ?? false;

  if (!totpEnabled) {
    throw new TotpRequiredForSmsError();
  }

  await Auth.updateMFAPreference({ sms: 'ENABLED' });
};

export default enableSmsMfaPreference;
